<div class="modal-container" *ngIf="show">
  <div class="product-search-container" (click)="closeAutocomplete()">
    <div class="tabs-content" *ngIf="!showResults">
      <p class="content-title">Busca de produtos</p>
      <lib-tabs [tabs]="tabs" [tabAlign]="1" (selectTab)="selectTab($event)" *ngIf="markets === 3"></lib-tabs>
      <div class="tab-content" *ngIf="tabs[0].active">
        <div [formGroup]="formLancamentos" class="search-lanc-form">
          <p class="search-label">Buscar produtos de lançamentos</p>
          <input
            type="text"
            name="mdl-i-real-estate-parent"
            id="real-estate-p-{{autocompTag}}"
            class="search-lanc-input"
            placeholder="Buscar"
            formControlName="search"
            maxlength="100"
            autocomplete="i-re-p"
            (input)="searchProductInput($event.target.value)"
            (keydown.enter)="searchLancamentos()"
            (keydown)="downList($event)"
          >
          <lib-button-secondary id="search-lanc-btn" class="search-lanc-btn" (click)="searchLancamentos()">Buscar</lib-button-secondary>
          <div class="search-lanc-autocomplete" *ngIf="autocomp">
            <div class="autocomplete-item" *ngFor="let result of autocompleteProducts; let i = index" [ngClass]="{'keyHover': i === autocompIdx}" (pointerover)="pointerSelection(i)" (click)="searchLancamentos(i)">
              <span [innerHTML]="result.name"></span>
              <span>&nbsp;(<span [innerHTML]="result.company.name"></span>)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content" *ngIf="tabs[1].active">
        <div [formGroup]="formProntos" class="search-prontos-form">
          <div class="search-prontos-form-field">
            <p class="search-label">Código do imóvel</p>
            <input type="text" id="real-estate-c-{{autocompTag}}" autocomplete="c-re" class="product-search-prontos-cod-input" formControlName="cod" placeholder="Ex.: 56473">
          </div>
          <div class="search-prontos-form-field">
            <p class="search-label">Endereço</p>
            <input
              type="text"
              name="mdl-i-real-estate"
              id="real-estate-a-{{autocompTag}}"
              class="product-search-prontos-add-input"
              formControlName="address"
              placeholder="Endereço"
              autocomplete="i-re"
              (input)="searchAddressInput($event.target.value)"
              (keydown.enter)="updateSearchInput(true)"
              (keydown)="downList($event)"
            >
          </div>
          <div class="search-prontos-form-field">
            <p class="search-label">Número</p>
            <input type="text" id="real-estate-n-{{autocompTag}}" autocomplete="n-re" class="product-search-prontos-num-input" formControlName="num" placeholder="Ex.: 10">
          </div>
          <lib-button-secondary id="search-prontos-btn" class="search-prontos-btn" (click)="searchProntos()">Buscar</lib-button-secondary>
          <div class="search-prontos-autocomplete" *ngIf="autocomp">
            <div class="autocomplete-item" *ngFor="let result of autocompleteAddress; let i = index" [ngClass]="{'keyHover': i === autocompIdx}" (pointerover)="pointerSelection(i)" (click)="updateSearchInput()">
              <span [innerHTML]="result.formattedAddress"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="product-search-added {{ tabs[0].active ? 'spa-tab-0' : 'spa-tab-1' }} {{ markets === 2 ? 'no-tab-0' : '' }} {{ markets === 1 ? 'no-tab-1' : '' }}">
        <p class="product-search-added-header" *ngIf="productsToAdd.length + productsToAddSession.length > 0">Produtos adicionados</p>
        <div class="product-search-added-item" *ngFor="let item of productsToAddSession; let j = index">
          <span [innerHTML]="item.name"></span>
          <div class="remove-added-item-btn" (click)="removeSessionItemToAdd(j)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z" fill="#2A2A2A"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="content-footer">
        <lib-button-tertiary id="search-products-cancel" class="search-product-modal-btn" (click)="closeSearchModal()">Cancelar</lib-button-tertiary>
        <lib-button-primary id="search-products-confirm" class="search-product-modal-btn" (click)="finishModal()">Concluir</lib-button-primary>
      </div>
    </div>
    <div class="results-content" *ngIf="showResults">
      <div class="results-header">
        <div id="search-products-results-back" class="header-back-btn" (click)="backToSearch()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.828 7.00017H16V9.00017H3.828L9.192 14.3642L7.778 15.7782L0 8.00017L7.778 0.222168L9.192 1.63617L3.828 7.00017Z" fill="black"/>
          </svg>
          <span>Voltar</span>
        </div>
      </div>
      <p class="results-empty" *ngIf="productsResult && productsResult.length == 0">
        Nenhum produto encontrado
      </p>
      <p *ngIf="productsResult && productsResult.length > 0">
        {{ totalResults > 9 ? '' : '0' }}{{ totalResults }} produto{{ totalResults > 1 ? 's' : '' }} encontrado{{ totalResults > 1 ? 's' : '' }}
      </p>
      <div class="results-list" (scroll)="incrementList()">
        <div class="results-loading" *ngIf="!productsResult">
          <lib-loading></lib-loading>
        </div>
        <ng-container *ngIf="productsResult">
          <div [id]="lastId === item.id ? 'last-product' : 'search-products-results-item-i'" class="results-item" *ngFor="let item of productsResult; let i = index" (click)="checkItem(i)">
            <span [innerHTML]="item.name"></span>
            <lib-input-checkbox id="search-products-results-item-{{i}}-chk" (click)="checkItem(i, $event)" [ngModel]="item.checked"></lib-input-checkbox>
          </div>
        </ng-container>
        <div class="more-results-loading" *ngIf="searching">
          <lib-loading></lib-loading>
        </div>
      </div>
      <div class="results-footer" *ngIf="productsResult && productsResult.length > 0">
        <lib-button-tertiary id="search-products-results-cancel" class="results-modal-btn" (click)="backToSearch()">Cancelar</lib-button-tertiary>
        <lib-button-primary id="search-products-results-confirm" class="results-modal-btn" (click)="finishAddingProducts()">Adicionar</lib-button-primary>
      </div>
    </div>
  </div>
</div>
